import { dedicatedReportsApi } from '../../api/dedicatedReports'
import { DedicatedReportShell, Limitations } from './DedicatedReportShell'
import { FlowTable } from './FlowTable'

/** R3-22 — qualità: scarti (rifiutate, annullate) e storni, per settore, operatore e agente. */
export function QualityReportPage() {
  return (
    <DedicatedReportShell title="Report qualità" icon="fact_check" load={dedicatedReportsApi.quality}>
      {d => (
        <>
          <div className="text-muted md-typescale-body-small mb-2">Dal {d.period.from} al {d.period.to}.</div>
          <FlowTable first="Totale" rows={[d.total]} />
          <FlowTable first="Settore" rows={d.byDepartment} />
          <FlowTable first="Operatore" rows={d.byOperator} />
          <FlowTable first="Agente" rows={d.byAgent} />
          <Limitations items={d.limitations} />
        </>
      )}
    </DedicatedReportShell>
  )
}
